import './SiteLoader.css';

function SiteLoader() {
  return (
    <div className="site-loader" role="status" aria-label="Loading inmotion">
      <img
        src="/inmotion logo.jpeg"
        alt="inmotion"
        className="site-loader__logo"
      />
    </div>
  );
}

export default SiteLoader;
